"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button = __importStar(require("./A_Button"));
var Component = function (p) {
    return (Preact.h(Button.Component, { "data-testid": "".concat(p.label, "-option"), onClick: p.onLabelClick, color: p.active ? 'primary' : 'secondary', sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textTransform: 'capitalize',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        }, disableRipple: true },
        Preact.h(p.Icon, { size: "small" }),
        Preact.h(Typography_1.default, { variant: "body2", sx: { marginTop: '10px', fontWeight: 600 } }, p.label)));
};
exports.Component = Component;
